// extracted by mini-css-extract-plugin
module.exports = {"empty-message":"styles_empty-message__3XT79","emptyMessage":"styles_empty-message__3XT79"};